export default __webpack_public_path__ + "static/media/webstorm.6cac5400.svg";